import React, { FunctionComponent } from 'react';


//----------------------------------------------------------------------
// COMPONENT
//----------------------------------------------------------------------

const SelectLoadingIndicator: FunctionComponent = () => {
    return <></>;
};

export default SelectLoadingIndicator;
